import { useCallback } from 'react'
import { router } from 'expo-router'
import { useOrderState } from '@order/hooks/useOrderState'
import useSession from 'hooks/useSession'
import useAvatarFlow from 'features/avatar/useAvatarFlow'
import { debugSteps } from '@order/utils/getDebugLog'
import { Deal } from '@ca/common/types'
import { useDealSelect } from './useDealTypeModal'

const toParams = (params?: Record<string, string | number>) => {
  if (!params) {
    return ''
  }

  const entries = Object.entries(params)
  if (entries.length === 0) {
    return ''
  }

  const searchParams = new URLSearchParams()
  entries.forEach(([key, value]) => {
    searchParams.set(key, value.toString())
  })

  return `?${searchParams.toString()}`
}

export default function useRestartOrder() {
  const { isAvatarFlow } = useAvatarFlow()
  const resetOrder = useOrderState((s) => s.reset)
  const resetDeals = useSession((s) => s.resetDeals)
  const { selectDeal } = useDealSelect()

  const restart = useCallback(
    (options?: {
      params?: Record<string, string | number>
      clearPendingOrder?: boolean
      avatarFlow?: boolean
      skipNavigate?: boolean
      flowName?: string
      deal?: Deal
    }) => {
      debugSteps.log('restart', { flowName: options?.flowName })
      resetOrder()
      resetDeals(options?.clearPendingOrder ?? true)

      const avatarFlow = options?.avatarFlow ?? isAvatarFlow

      if (options?.skipNavigate) {
        return
      }
      if (options?.deal) {
        selectDeal({
          deal: options.deal,
          bundle: 'base',
          onSelected: () => {
            if (router.canDismiss()) {
              router.dismissAll()
            }
            router.navigate('/frame/select')
          },
        })
        return
      }

      if (router.canDismiss()) {
        router.dismissAll()
      }

      if (avatarFlow) {
        router.navigate('/frame/select')
        return
      }

      const paramsString = toParams(options?.params)
      router.navigate(`/configuration/deal/select${paramsString}`)
      return
    },
    [resetOrder, resetDeals, selectDeal, isAvatarFlow]
  )

  return { restart }
}
